module.exports = __webpack_public_path__ + "static/media/baby.31e789de.jpg";